module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-slash-4d4ad0c3.svg";